import React from "react";

import StatisticsCard from "../StatisticsCard";
import NavBarMenu from "../NavBarMenu";
import FooterMenu from "../FooterMenu";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import BarChartAcademyUsers from "../graphs/barChartAcademyUsers";
import BarChartAcademyCourses from "../graphs/barChartAcademyCourses";

export const updateInstanceAcademy = () => {
  window.home.updateData();
}

class academy extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          refresh: false
      };
      window.home = this;
  }

  async updateData() {
     this.setState({ refresh: this.refresh = !this.refresh })
  }

  render() {
    return (
      <>
        <NavBarMenu/>
        <main key={this.state.refresh}>
          <Container fluid>
              <Row className="display-flex">
                <Col fluid={"true"}>
                  <StatisticsCard data={{id: "activeBridgeUsers"}}/>
                </Col>
                <Col fluid={"true"}>
                  <StatisticsCard data={{id: "coursesComplete"}}/>
                </Col>
              </Row>
              <Row className="display-flex">
                <Col fluid={"true"} lg={12}>
                  <BarChartAcademyUsers/>               
                </Col>
                <Col fluid={"true"} lg={12}>
                  <BarChartAcademyCourses/>              
                </Col>
              </Row>
          </Container>
        </main>
        <FooterMenu />
      </>
    )
  };
}

export default academy;